import { createAction } from 'src/lib/createAction';

export const navigationActions = {
  open: createAction('navigation/open')(),
  close: createAction('navigation/close')(),
} as const;
